import { FC } from 'react';
import parse from 'html-react-parser';
import styled from '@emotion/styled';

import { rem } from '@app/styles/theme/layout';

import { stripHTML } from '../helpers';

export enum ParsedContentFormat {
  PlainText = 'plain-text',
  ParseReact = 'parse-react',
}

const ParsedContent: FC<{
  format?: ParsedContentFormat;
}> = ({ format = ParsedContentFormat.PlainText, children }) => {
  if (typeof children !== 'string') return <>{children}</>;

  return format === ParsedContentFormat.ParseReact ? (
    <ParsedContainer>{parse(children)}</ParsedContainer>
  ) : (
    <>{stripHTML(children)}</>
  );
};

export default ParsedContent;

const ParsedContainer = styled.span`
  & p {
    margin: 0;

    &:not(:last-child) {
      margin-bottom: ${rem(4)};
    }
  }
`;
